<div mat-dialog-title>
	<h2 [innerHTML]="data.textkeyPrefix + '.energy.map.overlay.headline' | translate"></h2>
</div>

<mat-dialog-content [formGroup]="form">
	<div class="grid-x grid-margin-x">
		<div class="cell">
			<div [innerHTML]="data.textkeyPrefix + '.energy.map.overlay.teaser' | translate"></div>
		</div>

		<div class="cell">
			<div class="radio-wrapper">
				<mat-radio-group formControlName="energy_map_confirm_donation">
					<div class="cell">
						<mat-radio-button name="energy_map_confirm_donation" value="y" color="primary">
							<span [innerHTML]="data.textkeyPrefix + '.energy_map_confirm_donation.y.label' | translate"></span>
						</mat-radio-button>
					</div>
					<div class="cell">
						<mat-radio-button name="energy_map_confirm_donation" value="n" color="primary">
							<span [innerHTML]="data.textkeyPrefix + '.energy_map_confirm_donation.n.label' | translate"></span>
						</mat-radio-button>
					</div>
				</mat-radio-group>
			</div>
		</div>
	</div>
</mat-dialog-content>

<mat-dialog-actions>
	<div class="grid-x grid-margin-x">
		<div class="cell shrink medium-2">
			<a class="button darker-gray hollow" [routerLink]="data.lastStep" [mat-dialog-close]="'back'"><i class="icon-chevron-left"></i></a>
		</div>
		<div class="cell auto medium-10">
			<button mat-button class="button primary inline-arrow-right" cdkFocusInitial [innerHTML]="'step.button.next' | translate"
              [ngStyle]="form.valid === false ? {pointerEvents: 'none'} : ''" [class.disabled]="form.valid === false" (click)="submitForm()"></button>
		</div>
	</div>
</mat-dialog-actions>
